import { render, staticRenderFns } from "./PlainOptionList.vue?vue&type=template&id=28e0c428&scoped=true"
import script from "./PlainOptionList.vue?vue&type=script&lang=js"
export * from "./PlainOptionList.vue?vue&type=script&lang=js"
import style0 from "./PlainOptionList.vue?vue&type=style&index=0&id=28e0c428&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e0c428",
  null
  
)

export default component.exports